import { render, staticRenderFns } from "./SuccessVerification.vue?vue&type=template&id=7fca0982&"
import script from "./SuccessVerification.vue?vue&type=script&lang=js&"
export * from "./SuccessVerification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports